import { Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  minHeightFeetList,
  maxHeightFeetList,
  inchesList,
} from "../helper";
import { useHeightFilter } from "../filters/useHeightFilter";

const FilterHeight = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    minFeet,
    minInches,
    maxFeet,
    maxInches,
    setMinFeet,
    setMinInches,
    setMaxFeet,
    setMaxInches,
    isDisabled,
    buildHeightFilter,
  } = useHeightFilter(talentFilter, talentFilterTags);

  const handleAdd = () => {
    const payload = buildHeightFilter();
    if (!payload) return;

    onAddFilter("height", payload);
  };

  return (
    <div className="p-[12px]">
      <div>Select height range</div>

      <div className="border border-[#D9D9D9] rounded py-1 px-2 filter-select mb-2">
        <div>MIN</div>
        <Select
          placeholder="Feet"
          value={minFeet}
          options={minHeightFeetList}
          onChange={setMinFeet}
          style={{ width: 120 }}
        />
        <Select
          placeholder="Inches"
          value={minInches}
          options={inchesList}
          onChange={setMinInches}
          style={{ width: 120 }}
        />
      </div>

      <div className="border border-[#D9D9D9] rounded py-1 px-2 filter-select">
        <div>MAX</div>
        <Select
          placeholder="Feet"
          value={maxFeet}
          options={maxHeightFeetList}
          onChange={setMaxFeet}
          style={{ width: 120 }}
        />
        <Select
          placeholder="Inches"
          value={maxInches}
          options={inchesList}
          onChange={setMaxInches}
          style={{ width: 120 }}
        />
      </div>

      <div className="text-right">
        <Button
          disabled={isDisabled}
          className="mt-[10px]"
          onClick={handleAdd}
          icon={<PlusOutlined />}
        >
          Add Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterHeight;
